<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { WorkCalendar } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import WorkCalendarForm from './WorkCalendarForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        workCalendar: WorkCalendar;
    }>();

    const form = useForm({
        name: props.workCalendar.name,
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="route('v2.salary.work-calendars.update', workCalendar.id)"
        method="patch"
        :query-key="[QueryKey.WORK_CALENDARS]"
        title="work-calendars.update"
    >
        <WorkCalendarForm :form="form" />
    </DialogForm>
</template>
